import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/employeeSchedule'

const employeeSchedule = axios.create({
  baseURL
})

interceptorsSetup(employeeSchedule)

export default class EmployeeSchedule {
  static async getTable (scheduleQuery) {
    const result = await employeeSchedule.get('/' + scheduleQuery.siteId, {
      params:
      {
        start: scheduleQuery.start,
        end: scheduleQuery.end
      }
    })
    return result.data
  }
  static async createSchedule (schedule) {
    const result = await employeeSchedule.post('/', schedule)
    return result.data
  }
  static async updateSchedule (schedule) {
    const result = await employeeSchedule.post('/update', schedule)
    return result.data
  }
  static async archiveSchedule (schedule) {
    const result = await employeeSchedule.put('/archive/' + schedule)
    return result.data
  }
  static async archiveAllSchedules (employeeId, date) {
    const result = await employeeSchedule.post('/archive/all/', { id: employeeId, date: date })
    return result.data
  }
  static async archiveShiftSchedules (employeeId, date, shift) {
    const result = await employeeSchedule.post('/archive/shift/', { id: employeeId, date: date, shift: shift })
    return result.data
  }
}
